export { TextContent } from './TextContent';
